<template>
  <div>
    <div class="d-flex flex-stack" v-if="aggrementContents.length > 0">
      <div class="d-flex justify-content-end fw-semibold text-primary fs-base gap-5 me-6" v-for="item in aggrementContents" v-bind:key="item">
        <a href="#" class="text-muted text-hover-primary" @click="getContentDetail(item)" data-bs-toggle="modal" data-bs-target="#kt_modal_content_detail" 
          data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end">
          {{ item.pages_content_title }}
        </a>
      </div>
    </div>

    <button type="button" class="d-none btn btn-sm" data-bs-toggle="modal" data-bs-target="#kt_modal_content_detail" data-kt-menu-trigger="click" ref="openContentApprovalModal"></button>
  
    <div class="modal fade" id="kt_modal_content_detail" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" role="dialog" aria-modal="true">
        <div class="modal-dialog modal-dialog-centered modal-lg">
            <div class="modal-content">
                <div class="modal-header bg-primary" id="kt_modal_add_user_header">
                    <h2 class="modal-title text-white fw-bolder col-md-10">
                      {{contentDetail.name}}
                      <div class="badge badge-success ms-3" v-if="contentDetail.is_approved == 1"> {{$t('approved')}} </div>
                      <div class="badge badge-danger ms-3" v-if="contentDetail.is_approved !== 1 && this.userData.package_type !== 0 && this.contentDetail.menu_selection == '/MembershipAgreementHelppage'"> {{$t('approval_required')}} </div>
                    </h2>  
                    <div class="btn btn-icon btn-sm btn-active-icon-primary" data-bs-dismiss="modal" ::aria-label="$t('close')" ref="closeContentModal" @click="onCloseContentModal()">
                        <span class="svg-icon svg-icon-1 text-white text-hover-dark">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                viewBox="0 0 24 24" fill="none">
                                <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1"
                                    transform="rotate(-45 6 17.3137)" fill="currentColor"></rect>
                                <rect x="7.41422" y="6" width="16" height="2" rx="1"
                                    transform="rotate(45 7.41422 6)" fill="currentColor"></rect>
                            </svg>
                        </span>
                    </div>
                </div>
                <div class="modal-body" :class="{'overlay overlay-block': this.isApproving == true}">
                  <div ref="documentToDownload" v-html="contentDetail.pages_content_content"></div>

                  
                  <div class="overlay-layer bg-dark bg-opacity-5" v-if="this.isApproving == true">
                      <div class="spinner-border text-primary" role="status">
                          <span class="visually-hidden">{{ $t('loading') }}</span>
                      </div>
                  </div>
                </div>
                <div class="modal-footer flex-stack">
                  <button type="button" class="btn btn-secondary" @click="exportToPDF()">
                    <i class="bi bi-download pe-0"></i> {{$t('download')}}
                  </button>
                  <button v-if="this.contentDetail.is_approved !== 1" type="button" class="btn btn-success float-end" @click="onConfirmContent()">
                    <i class="bi bi-check pe-0"></i>
                    {{$t('approve')}}
                  </button>
                  <div v-else class="d-flex align-items-center">
                      <div class="symbol symbol-30px symbol-circle me-3">
                        <span class="symbol-label bg-success">
                          <i class="bi bi-check fs-5 text-white"></i>
                        </span>
                      </div>
                      <div class="m-0">
                          <span class="fw-semibold text-gray-500 d-block fs-8">{{ $t('approved_at') }}</span>
                          <a href="#" class="fw-bold text-gray-800 text-hover-primary fs-7"> {{previewDate(contentDetail.approved_at)}} </a>
                      </div>
                  </div>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import html2pdf from 'html2pdf.js';
import moment from 'moment';
export default {
  name: "Contents",
  data() {
    return {
      userData: this.$getUser(),
      aggrementContents: [],
      contentDetail: {},
      isApproving: false
    };
  },
  computed: {
    previewDate(){
      return (value)=>{
        if (value) {
          return moment(new Date(value)).format('DD.MM.YYYY HH:mm')
        }
      }
    },
  },
  methods: {
    getAgreementContents() {
      const parameters = {
        session_id: this.$getUser().session_id,
        country_code: (this.$getUser().company_country_code) ? this.$getUser().company_country_code : null,
      };
      axios.post("api/Helper/GetContents", parameters, {"Content-Type": "application/json",})
      .then((response) => {
        this.aggrementContents = response.data;
        if(this.userData !== null && this.userData !== '' && this.userData !== undefined) {
          if(this.aggrementContents.find(item => item.menu_selection == "/MembershipAgreementHelppage" && this.userData.package_type !== 0 && item.is_approved !== 1)) {
            this.getContentDetail(this.aggrementContents.find(item => item.menu_selection == "/MembershipAgreementHelppage"));
            setTimeout(() => {
              this.$refs.openContentApprovalModal.click();
            }, 1000);

          }
        }
      })
      .catch((error) => {
        console.error(error);
      });
    },
    getContentDetail(selectedContent) {
      const parameters = {
				country_code: (this.$getUser().company_country_code) ? this.$getUser().company_country_code : null,
        menu_selection: selectedContent.menu_selection,
        session_id: this.$getUser().session_id
			}
			axios.post('api/NewCompany/GetAggrementContents', parameters, {'Content-Type': 'application/json'})
			.then((response) => { 
				this.contentDetail = response.data[0];
        this.contentDetail.is_approved = selectedContent.is_approved;
        this.contentDetail.approved_at = selectedContent.approved_at;
			})
			.catch((error) => {
				console.error(error);
			});
    },
		exportToPDF() {
			html2pdf(this.$refs.documentToDownload, {
				margin: 1,
				filename: this.contentDetail.name + '.pdf',
				image: { type: 'jpeg', quality: 0.98 },
				html2canvas: { dpi: 192, letterRendering: true },
				jsPDF: { unit: 'in', format: 'letter', orientation: 'landscape' }
			});
		},
    onConfirmContent() {
      this.$swal.fire({
          title: "Are you sure you want to approve "+ this.contentDetail.name + "?",
          confirmButtonColor: "#50cd89",
          showDenyButton: false,
          showCancelButton: true,
        cancelButtonText: this.$t('cancel'),
          confirmButtonText: this.$t('save'),
          icon: 'info'
      })
      .then((result) => {
        if (result.isConfirmed) {
          this.isApproving = true;
          const parameters = {
            session_id: this.$getUser().session_id,
            account_id: this.$getUser().id,
            channel: "User Interface",
            release_date: this.contentDetail.release_date,
            content_name: this.contentDetail.name,
            content_id: this.contentDetail.id,
            is_approved: 1,
            operation: this.contentDetail.name + " consent approved",
            lang: localStorage.getItem('locale') || this.$i18n.locale || 'en',
          };  
          const that = this;
          axios.post('/api/Notification/SaveNotification', parameters, {'Content-Type': 'application/json'})
          .then((response) => {
            if(response.data.error == null || response.data.error == 'undefined' || response.data.error == ''){
                this.contentDetail.is_approved = 1;
                this.$swal(this.$t('success'), this.$t('content_approved_successfully'), 'success');  
                this.$refs.closeContentModal.click();
                this.getAgreementContents();
            }
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => { 
              setTimeout(() => {
                that.isApproving = false;
              }, 500);
          });  
        }
      }); 
    },
    onCloseContentModal() {
      if (this.contentDetail.is_approved !== 1 && this.userData.package_type !== 0 && this.contentDetail.menu_selection == '/MembershipAgreementHelppage') return;
      this.contentDetail = {};
    }
  },
  created() {
    this.getAgreementContents();
  },
  mounted() {
    if(this.userData !== null && this.userData !== undefined && this.userData !== '') {
      const modalEl = document.getElementById('kt_modal_content_detail');
      modalEl.addEventListener('hide.bs.modal', (e) => {
        if (this.contentDetail.is_approved !== 1 && this.userData.package_type !== 0 && this.contentDetail.menu_selection == '/MembershipAgreementHelppage') {
          e.preventDefault();
          this.$swal(this.$t('failed'), this.$t('modal_cannot_be_closed_without_approving_the_content'), 'error');   
        }
      });
    }
  }
};
</script>